<template>
    <div class="footer">
        <div class="footer-left">
            <div class="routes">
                <ul>
                    <li><router-link to="/">{{ $t('route1') }}</router-link></li>
                    <li><router-link to="/services">{{ $t('route2') }}</router-link></li>
                    <li><router-link to="/references">{{ $t('route3') }}</router-link></li>
                    <li><router-link to="/fences">{{ $t('route5') }}</router-link></li>
                    <li><router-link to="/contact">{{ $t('route4') }}</router-link></li>
                </ul>
            </div>
            <div class="contacts">
                <div class="contact">
                    <li>Kocsis Péter, {{ $t('footer-mob') }}: +36302641698</li>
                    <li>Email: <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@ko-technics.com" target="_blank">info@ko-technics.com</a></li>
                    <li>2900 Komárom, Térffy Gyula 29.</li>
                </div>
            </div>
        </div>
        <div class="footer-right">
            <router-link to="/">
                <img class="logo" src="/images/logo.png" alt="">
            </router-link>
            <h3>&copy; KO-technics Kft. 2023</h3>
        </div>

    </div>
</template>

<script setup>

</script>

<style lang="css" scoped>


.footer {
    width: 100%;
    height: 100%;
    padding: 40px 30px;
    background-color: #181818;
    color: #FEF7F8;
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.footer h3,
p {
    margin: 0;
}

.footer p {
    font-size: 18px;
    max-width: 600px;
}

.footer-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    height: 140px;
}

.footer-left p {
    font-size: 14px;
}

.routes {
    display: flex;
    justify-content: start;
    align-items: center;
    margin: 0;
}

.routes ul {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    gap: 60px;
    padding: 0;
    margin: 0;
}

.routes ul li a {
    text-decoration: none;
    color: #f5f5f5;
    font-size: 16px;
    transition: ease-in-out 200ms;
}

.routes ul li a:hover {
    color: #FFDD00;
    transition: ease-in-out 200ms;
}

.routes ul li a.router-link-exact-active {
    font-weight: 500;
    color: #FFDD00;
}

.footer-right {
    display: flex;
    justify-content: space-between;
    align-items: end;
    flex-direction: column;
    height: 140px;
}

.contacts {
    display: flex;
    flex-direction: column;
    align-items: start;
    height: auto;
    justify-content: space-between;
    list-style: none;
}

.contact {
    display: block;
}

.contact a {
    color: #9E9EFF;
    text-decoration: none;
}

.logo {
    height: 70px;
}

@media only screen and (max-width: 1540px) {

    .footer-left {
        height: 140px;
    }

    .footer-left p {
        font-size: 12px;
    }

    .footer-right {
        height: 140px;
    }

    .routes ul {
        gap: 40px;
    }

    .routes ul li a {
        font-size: 14px;
    }
}

@media only screen and (max-width: 1400px) {

    .footer {
        height: 100%;
    }

    .footer p {
        max-width: 600px;
    }

    .footer-left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;
    }

    .footer-left p {
        font-size: 14px;
    }

    .routes ul {
        gap: 40px;
    }

    .routes ul li a {
        font-size: 14px;
    }

    .footer-right {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        gap: 20px;
    }

    .contacts {
        display: flex;
        align-items: start;
        height: auto;
        justify-content: space-between;
    }
}

@media only screen and (max-width: 1100px) {

    .footer p {
        max-width: 350px;
    }

    .routes li {
        margin: 5px 0;
    }

    .contact li {
        margin-bottom: 2px;
    }

    .logo {
        height: 50px;
    }

}

@media only screen and (max-width: 1040px) {
    .footer {
        flex-direction: column;
        gap: 40px;
    }

    .footer li, a {
        font-weight: 500;
    }

    .footer-right {
        height: 100%;
        align-items: center;
        justify-content: center;
        padding: 0;
        gap: 10px;
    }

    .footer-left {
        padding: 0;
        height: 100%;
        gap: 20px;
        display: flex;
        align-items: center;
    }

    .contact {
        margin: 2px 0
    }


    .logo {
        width: 250px;
        height: auto;
    }

}

@media only screen and (max-width: 830px) {

    .footer-right {
        align-items: center;
    }

    .contact li {
        font-size: 14px;
    }

    .routes ul li {
        margin: 0;
    }
    
    .routes ul {
        display: block;
        text-align: center;
    }

}

@media only screen and (max-width: 602px) {


    .routes ul li a{
        font-size: 14px;
        margin: 2px;
    }
}
</style>